import React from 'react';
import PropTypes from 'prop-types';
import ContentText from 'Components/ContentText';
import Link from 'Components/Link';
import DealerModel from 'Stores/DealerModel';
import styles from './styles.scss';
import { getGivenBackground } from 'Utils/getColor';

const DealerImprint = ({ dealer }) => {
  return (
    <ContentText
      className={styles.textBlock}
      headline={{
        value: 'Verantwortliche Stelle 2:',
        forceUppercase: true,
        level: 'h2',
        className: 'h4',
      }}
      background={getGivenBackground('light')}
    >
      <address>
        <p>{dealer.name}</p>
        <p>
          {dealer.legalContact.street} {dealer.legalContact.houseNumber}
          <br />D – {dealer.legalContact.postalCode} {dealer.legalContact.city}
        </p>
        <p>
          Telefon:{' '}
          <Link to={`tel:${dealer.legalContact.phone}`} label={dealer.legalContact.phone} />
          <br />
          E-Mail:{' '}
          <Link to={`mailto:${dealer.legalContact.email}`} label={dealer.legalContact.email} />
        </p>
      </address>
      <p>
        Handelsregisternummer: {dealer.registrationNumber}
        <br />
        Handelsgericht & Registergericht: {dealer.registrationCourt}
        <br />
        Ust-ID-Nr.: {dealer.taxId}
      </p>
      {dealer.authorisedRepresentatives.length > 0 && (
        <p>Vertretungsberechtige(r): {dealer.authorisedRepresentatives.join(', ')}</p>
      )}
      {dealer.settings.imprint.text && (
        <div
          className={[styles.topSpacing, styles.dealerImprintText].join(' ')}
          dangerouslySetInnerHTML={{ __html: dealer.settings.imprint.text }}
        />
      )}
    </ContentText>
  );
};

DealerImprint.propTypes = {
  dealer: PropTypes.instanceOf(DealerModel).isRequired,
};

export default DealerImprint;
